import React from 'react';
import key from 'weak-key';

// components
import { ContentElement } from 'components/ContentElements/ContentElement';

interface ContentProps {
  content: any[];
  currentIndex: number;
}

function Content({ content, currentIndex }: Readonly<ContentProps>) {
  if (!content) return null;

  return (
    <div data-preview-id={`#${currentIndex}`}>
      <div data-preview-id={`#${content.catalogName}`}>
        {content.content?.map((element, subIndex) => (
          <div key={key(element)} data-preview-id={`#${subIndex}`}>
            <ContentElement
              // coding guideline exception: we spread all server props to the component
              {...element}
              key={key(element)}
              contentIndex={subIndex}
              contentLength={content.content.length}
              isChild
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default Content;
